import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from '../project.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../helper/shared/shared.service';
import { faInfoCircle, faChevronCircleRight, faCheckCircle, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { NgbNavConfig } from '@ng-bootstrap/ng-bootstrap';
import { createPopper } from '@popperjs/core';
import { isNullOrUndefinedObject } from 'src/app/helper/validation';
import { ProjectComponent } from '../project.component';
import { UserInfoService } from '../../user-info/user-info.service';
import { CalculateService } from '../../helper/calculate/calculate.service';

//Apache Echarts
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { TitleComponent, ToolboxComponent, TooltipComponent, GridComponent, LegendComponent, VisualMapComponent } from 'echarts/components';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'; //Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros

echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  VisualMapComponent,
  LineChart,
  UniversalTransition,
  CanvasRenderer,
]);

declare var require: any;

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})

export class ResultComponent implements OnInit {
  @ViewChild("nav") nav: any;
  @Output() nextStep = new EventEmitter<String>();
  @ViewChild('calcOutOfRangeWarning', { static: false }) myModal: any; //Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros
  faAngleRight = faAngleRight;
  faInfoCircle = faInfoCircle;
  faCheckCircle = faCheckCircle;
  faChevronCircleRight = faChevronCircleRight;

  compileMsg = "";
  genResMsg = "";
  failedMsg = "";
  NumberFormat = '';

  loading: boolean;
  selected = 'Snapshot';

  ComparisonInfo: any;
  SnapshotInfo: any;
  UnitsFromUserData: any;
  AllDDLList: any;
  selectedSolution: any = {};

  state = 1;
  projectInfo;
  contamination;
  solutions;
  results;

  //Snapshot Graphs
  data_EffvsLifeTimeEChart: any = [];
  legend_EffvsLifeTimeEChart: any = [];
  EffvsLifeTimeEchartOptions: any;

  //Comparison Graph
  data_ComparisonEffvsLifeTimeEChart: any = [];
  legend_ComparisonEffvsLifeTimeEChart: any = [];
  ComparisonEffvsLifeTimeEchartOptions: any;

  MaxNumOfMedia: any = [];

  gAryColors = ['#00673E', '#818b98', '#f99f20']; //Modified by PP(2023-01-20) : Follow Camfil Colors
  selectedConcUnit = "";

  closeResult: string; //Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros

  constructor(
    public projectService: ProjectService,
    private route: ActivatedRoute,
    public sharedService: SharedService,
    private toastr: ToastrService,
    private userInfoService: UserInfoService,
    private calculateService: CalculateService,
    public ProjectComponent: ProjectComponent,
    private router: Router,
    private modalService: NgbModal //Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros
  ) { }

  ngOnInit(): void {
    this.loading = true;
    window.scroll(0, 0);
    this.selected = "Snapshot";

    this.sharedService.FromProgramSettings = false;
    this.sharedService.UserInfoMode = false;
    this.sharedService.CalculationInProgress = false; //Modified by PP(2023-06-06) : If load project, change airflow straight click Results tab then it hangs. Contamination page defined as true but only will false after calculation finish

    //this.initiateList();
    this.initiateData();
    this.getSolutions();
  }

  ngAfterContentInit() {
    //this.getSolutions(); 

  }

  ngAfterViewInit() {
    this.setPoppers();

    //Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros - START
    setTimeout(() => {
      if (this.sharedService.CalculationForEfficiencyFailed) {
        this.modalService.open(this.myModal, {
          ariaLabelledBy: 'modal-basic-title',
          centered: true,
          backdrop: 'static'
        }).result.then((result) => {
        }, (reason) => {
          this.closeResult = `Dismissed`;
        });
      }
    }, 5);
    //Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros - END

    // setTimeout(() => {
    //   var abc=123;
    // }, 5);
  }

  initiateList() {

  }

  initiateData() {
    this.AllDDLList = this.sharedService.listData;

    //Modified by PP(2023-02-28) : Get from userino. If no data, then projectinfo - START
    // if (this.projectService.projectdetails.projectInfo != null || this.projectService.projectdetails.projectInfo != undefined) {
    //   if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
    //     this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
    //   } else {
    //     this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
    //   }
    // }

    if (this.userInfoService.userData != null || this.userInfoService.userData != undefined) {
      if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
        this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
      } else {
        this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
      }
    } else {
      if (this.projectService.projectdetails.projectInfo != null || this.projectService.projectdetails.projectInfo != undefined) {
        if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
          this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
        } else {
          this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
        }
      }
    }
    //Modified by PP(2023-02-28) : Get from userino. If no data, then projectinfo - END

    if (this.userInfoService.userData.NumberFormatId === 1) {
      this.NumberFormat = 'sv-SE';
    } else if (this.userInfoService.userData.NumberFormatId === 2) {
      this.NumberFormat = 'en-US';
    }

    switch (this.userInfoService.userData.UserConcUnit) {
      case "ppb":
        this.selectedConcUnit = "ppb";
        break;
      case "mg/m³":
        this.selectedConcUnit = "mg/m³";
        break;
    }
  }

  getSolutions() {
    if (this.route.snapshot.url[0].path.toLowerCase() == 'projectedit' && this.sharedService.blnLoadFromRecord === true) {
      ''
      this.projectService.listData = this.sharedService.listData;
      //this.projectService.callLoadProjectApi(this.sharedService.ProjectToEdit.id,true).subscribe(
      //res =>{
      if (this.sharedService.blnLoadFromRecord == true) {
        this.projectService.listData = this.sharedService.listData;
        this.projectService.getProjectStructure(this.sharedService.loadFromDatabase);
        //Modified by PS(2023-03-23): MCCLD 2023-Fix bugs-START
        /*let results={};
        results = this.projectService.getSolResultsStructure(this.sharedService.loadFromDatabase.Params.MCCLDResults);
        
        this.projectService.projectdetails.results=results;

        if (data !== undefined || data !== "") {
          this.initiateData();                    
        }
        
        //Get More Information values for contamination classes
        this.getMoreInfoForContamination();

        this.getViewinReport();*/
        let results: any = {};
        results = this.projectService.getSolResultsStructure(this.sharedService.loadFromDatabase.Params.MCCLDResults);
        if (results.ready) {
          this.projectService.projectdetails.results = results;

          //Get More Information for Solution Details after results structure is ready
          this.projectService.getMoreInfoForSolutionDetails();

          //Get More Information values for contamination classes
          this.getMoreInfoForContamination();

          this.getViewinReport();
        } else {
          this.toastr.error("Failed to calcualte the results", "",);
        }
        //Modified by PS(2023-03-23): MCCLD 2023-Fix bugs-END
        this.sharedService.blnLoadFromRecord = false;
        //this.loading = false;
      } else {
        this.triggerCalculation();
      }
    } else if (this.route.snapshot.url[0].path.toLowerCase() == 'importxml' && this.sharedService.projectNotCalc == false) {
      if (this.sharedService.LoadingXML == true) {
        this.projectService.listData = this.sharedService.listData;
        //let calcType = this.sharedService.importXMLData.Params.CalcType;
        let data = this.projectService.getProjectStructure(this.sharedService.importXMLData);
        let results = {};
        results = this.projectService.getSolResultsStructure(this.sharedService.importXMLData.Params.MCCLDResults);
        this.projectService.projectdetails.results = results;

        if (data !== undefined || data !== "") {
          this.initiateData();
          //   this.sharedService.blnLoadFromRecord = true;                 
        }

        //Get More Information for Solution Details after results structure is ready
        this.projectService.getMoreInfoForSolutionDetails();

        //Get More Information values for contamination classes
        this.getMoreInfoForContamination();

        this.getViewinReport();
        this.sharedService.LoadingXML = false;
      } else {
        this.triggerCalculation();
      }

    } else if (this.projectService.projectdetails.solutions && this.sharedService.blnLoadFromRecord === false) { // New Project
      if (this.projectService.projectdetails.projectInfo === undefined) {
        this.router.navigate(["home"]);
      } else {
        this.triggerCalculation();
      }
    }
  }

  /* getSolutionsORI() {
     if(this.route.snapshot.url[0].path.toLowerCase() == 'projectedit' && this.sharedService.blnLoadFromRecord === true) {
       this.projectService.listData = this.sharedService.listData;
       console.log("PS20230321 Check: => load selected record -START=> "   + new Date());
       this.projectService.callLoadProjectApi(this.sharedService.ProjectToEdit.id,true).subscribe(
         res =>{
           console.log("PS20230321 Check: => load selected record -END=> "   + new Date());
           console.log(res);
           if (res == null) {
             let msg = "Failed to load saved project! Please try again.";
             this.toastr.error(msg, "");
             this.loading = false;
           } else {
             let data=this.projectService.getProjectStructure(res); 
             
             if (res.Params.ExportType == 'Complete') {
               this.sharedService.projectNotCalc = false;
             } else {
               this.sharedService.projectNotCalc = true;
             }
 
             if (res.Params.CalcType === 'ASTM') {
               this.sharedService.calculationType = 'ASTM';
               this.router.navigate(['/projectedit', res.Params.ProjectInfo.ProjectID], { queryParams: { path  : this.sharedService.PathStringFromHomeComponent}});
             } else { //CLD
               if (this.sharedService.projectNotCalc) {
                 this.ProjectComponent.prevStep();
               }
                    
               //let calcType = res.Params.CalcType;
               let results={};
               results = this.projectService.getSolResultsStructure(res.Params.MCCLDResults);
               this.projectService.projectdetails.results=results;
   
               if (data !== undefined || data !== "") {
                 this.initiateData(); //Modified by PP(2022-11-17) : Display project into all pages
                 //this.sharedService.blnLoadFromRecord = false; //initially was false              
               }
   
               //Get More Information values for contamination classes
               this.getMoreInfoForContamination();
           
               if(data.results.solutionsResults !== undefined){           
                 this.getViewinReport();
               }
               this.sharedService.blnLoadFromRecord = false;
             }     
           }
         },
         err =>{
           this.loading = false;
           this.toastr.error("Failed to load saved project! Please try again.", "");
         }
       );
     } else if(this.route.snapshot.url[0].path.toLowerCase() == 'importxml' && this.sharedService.projectNotCalc == false) {
       if (this.sharedService.LoadingXML == true) {
         this.projectService.listData = this.sharedService.listData;
         //let calcType = this.sharedService.importXMLData.Params.CalcType;
         let data=this.projectService.getProjectStructure(this.sharedService.importXMLData);               
         let results={};
         results = this.projectService.getSolResultsStructure(this.sharedService.importXMLData.Params.MCCLDResults);
         this.projectService.projectdetails.results=results;
 
         if (data !== undefined || data !== "") {
           this.initiateData();
         //   this.sharedService.blnLoadFromRecord = true;                 
         }
 
         //Get More Information values for contamination classes
         this.getMoreInfoForContamination();
 
         this.getViewinReport();
         this.sharedService.LoadingXML = false;
       } else {
         this.triggerCalculation();
       }
 
     } else if (this.projectService.projectdetails.solutions && this.sharedService.blnLoadFromRecord === false) { // New Project
         this.triggerCalculation();
     }
   }*/

  next() {
    this.nextStep.emit();
  }

  Proceed() {
    this.next();
  }

  triggerCalculation() {
    if (this.projectService.generateResultRequired(true)) {
      let blnValidResult = this.projectService.ValidateDataEntries();

      if (blnValidResult === true) {
        console.log("results.triggerCalc" + new Date());
        this.sharedService.ServerData = this.sharedService.CompileDataForCalculation(this.projectService.projectdetails, 0); //0 = for all
        this.sharedService.CountTotalSeqForUploadingParams(this.sharedService.ServerData, "UPLOAD MCCLD PARAMS TO SERVER");
        this.PrepareToUploadParams();
      } else {
        this.toastr.warning("Failed to generate result, please check your entries!", "");
        this.failedMsg = "Failed to generate result, please check your entries!" + ' ' + this.projectService.errPage;
        this.loading = false;
      }
    } else {
      this.getViewinReport();
    }
  }

  PrepareToUploadParams() {
    var dataToUpload = this.sharedService.generateStr();
    console.log("PS20230321 Check: => UploadServerData2TempStringStorage - START=> " + new Date());
    this.projectService.UploadServerData2TempStringStorage(dataToUpload).subscribe(res => {
      console.log("PS20230321 Check: => UploadServerData2TempStringStorage - END=> " + new Date());
      if (res) {
        this.sharedService.TempStringStorageTotalPass = this.sharedService.TempStringStorageTotalPass + 1;
        this.sharedService.ServerDataReady = true;
        this.sharedService.UploadingEntry = false;
        if (this.sharedService.TempStringStorageTotalPass + this.sharedService.TempStringStorageTotalFail !== this.sharedService.TempStringStorageTotalSeq) {
          this.sharedService.TempStringStorageCurrentSeq = this.sharedService.TempStringStorageCurrentSeq + 1;
          this.PrepareToUploadParams();
        } else {
          if (this.sharedService.TempStringStorageTotalPass === this.sharedService.TempStringStorageTotalSeq) {
            console.log("PS20230321 Check: => Perform CLD Calculation -START=> " + new Date());
            this.projectService.PerformMCCLDCalculation(false, 0, false, false).subscribe(async data => {
              console.log("PS20230321 Check: => Perform CLD Calculation -END=> " + new Date());

              //Modified by PP(2023-10-24): Check for timeout of logincode - START
              if (data !== null) {
                if (data !== undefined) {

                  this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'SUCCESS_CALCULATION').subscribe(result => {                       
                    if (result) {}
                  });

                  if (data.SolutionResults.length > 0) {
                    console.log("results.endCalc" + new Date());
                    this.sharedService.CalculateMCCLDCompleted = true;
                    this.sharedService.ServerData.LCCResults = data;

                    //let calcType = this.sharedService.calculationType;
                    let results = {};
                    results = this.projectService.getSolResultsStructure(data);
                    this.projectService.projectdetails.results = results;
                    this.results = this.projectService.projectdetails.results;

                    var extcalcdesc = this.projectService.projectdetails.projectInfo.projectDesc;
                    var customername = this.projectService.projectdetails.customerInfo.customername;

                    //pplim 20251028
                    //if (extcalcdesc == "[EXTRACT CALCULATION]") {
                    if (String(extcalcdesc).includes("[EXTRACT CALCULATION]") || String(customername).includes("[EXTRACT CALCULATION]")) {
                      if (data.ExtractCalcInExcel.Path != "") {
                       
                        this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'GENERATE_REPORTS').subscribe(result => {                       
                          if (result) {}
                        });

                        try {
                          const blob = await this.sharedService.downloadFile(data.ExtractCalcInExcel.Path);
                          const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
                          const link = document.createElement('a');
                          link.href = url;
                          link.setAttribute('download', data.ExtractCalcInExcel.FileName);
                          document.body.appendChild(link);
                          link.click();
                          link.remove();
                        } catch (error) {
                          this.toastr.error('Error downloading excel')
                          console.error('Error downloading excel', error);
                        } finally {
                          this.toastr.success('MCCLD report : Successfully downloaded excel.')
                        }
                      }
                    }

                    if (this.results !== undefined) {
                      this.getViewinReport();
                    }
                  } else {
                    this.loading = false;
                    var extcalcdesc = this.projectService.projectdetails.projectInfo.desc;
                    if (extcalcdesc === '' || extcalcdesc === undefined) {
                      extcalcdesc = this.projectService.projectdetails.projectInfo.projectDesc;
                    }
                    if (extcalcdesc == "[EXTRACT CALCULATION]") {
                      this.toastr.error("Excel Object Error. Please remove Extract Calculation from Project Description and try again.", "");
                    } else {
                      this.toastr.error("Unable to calculate result. Please try again.", "");
                    }

                    this.ProjectComponent.prevStep();
                  }
                } else {
                  this.loading = false;
                  this.sharedService.CalculateMCCLDCompleted = false;
                  this.toastr.error("Unable to calculate result. Please try again.", "");
                }
              } else {
                this.sharedService.redirectToLoginPage();
                // this.userInfoService.userData.UserId = 0;
                // this.toastr.error('Session time out. Please login again.', '');
                // this.router.navigate(["login"]); 
              }
              //Modified by PP(2023-10-24): Check for timeout of logincode - END

            }, err => {
              this.loading = false;
              this.toastr.error("Probably Excel object failure. Please try again.", "");
            });
          } else { //if (this.sharedService.TempStringStorageTotalPass===this.sharedService.TempStringStorageTotalSeq)
            this.loading = false;
            this.toastr.error("Failed to upload Parameters for Calculation." + " TotalPass <> TotalSeq.", "");
          }
        }
      } else { //if (res)
        this.loading = false;
        this.sharedService.TempStringStorageTotalFail = this.sharedService.TempStringStorageTotalFail + 1;
        this.sharedService.UploadingEntry = false;
        this.sharedService.ServerDataReady = false;
        this.toastr.error("Failed to upload Parameters for Calculation." + " TotalFail>1.", "");
      }
    }, err => {
      this.loading = false;
      this.toastr.error("Failed to upload Parameters. Please try again.", "");
    });
  }

  getViewinReport() {
    this.projectInfo = this.projectService.projectdetails.projectInfo;
    this.contamination = this.projectService.projectdetails.contamination;
    this.solutions = this.projectService.projectdetails.solutions;
    this.results = this.projectService.projectdetails.results.solutionsResults;

    var showResults = false;
    if (this.results != undefined || this.results != null) {
      showResults = true;
    }

    if (showResults) {
      this.solutions.sort((a, b) => {
        return a.id - b.id;
      });

      //Modfified by PP(2023-05-12) : Bugs. If click on Snapshot tab it always go back to Solution 1 this.setState(this.selectedSolution);
      this.setState(this.state); //Modfified by PP(2023-05-12) : Bugs. If click on Snapshot tab it always go back to Solution 1

      //Default to More Information
      //Replace with this.projectService.getMoreInfoForSolutionDetails(); in getSolutions()
      // for (let i=0 ; i< this.solutions.length; i++) {
      //   for (let j=0 ; j< this.solutions[i].solutionDetails.length; j++) {
      //     if (this.solutions[i].solutionDetails[j].moreInformation == undefined) {
      //       for (let y=0; y< this.results.length; y++) {
      //         if (this.solutions[i].solutionID == this.results[y].solutionID) {
      //           for (let z=0; z< this.results[y].results.length; z++) {
      //             if (this.solutions[i].solutionDetails[j].combinationID == this.results[y].results[z].combinationID) {                                   
      //               let newMoreInfoDetails = this.projectService.getMoreInfoForSolutionEmptyvalueStructure();
      //               newMoreInfoDetails.effectiveMediaWeight = this.sharedService.formatValue(parseFloat(this.results[y].results[z].effMediaWeight.toFixed(2)), true);                                       
      //               newMoreInfoDetails.frontVelocity = this.sharedService.formatValue(parseFloat(this.results[y].results[z].frontVelocity.toFixed(2)), true);                                   
      //               newMoreInfoDetails.totalWeight = this.sharedService.formatValue(parseFloat(this.results[y].results[z].totalWeight.toFixed(2)), true);                    
      //               newMoreInfoDetails.contactTime = this.sharedService.formatValue(parseFloat(this.results[y].results[z].contactTime.toFixed(2)), true);
      //               this.solutions[i].solutionDetails[j].moreInformation = newMoreInfoDetails;
      //             }
      //           }                         
      //         }                           
      //       }              
      //    }
      //   }
      // } 

      this.projectService.projectDetails_successResult = this.projectService.convertProjectEntriesToJson(this.projectService.projectdetails);
      this.prepareValuesForComparisonPage();
      //this.populateDataToComparisonChartComponents();

      //this.loading = false; //Modified by PS(2023-03-23): MCCLD 2023-Fix bugs-START
    } else {
      //this.loading = false;//Modified by PS(2023-03-23): MCCLD 2023-Fix bugs-START
      this.toastr.error("Failed to generate result, please check your entries!", "");
    }
    this.loading = false; //Modified by PS(2023-03-23): MCCLD 2023-Fix bugs-START
  }

  prepareValuesForComparisonPage() {
    this.sharedService.CalculationForEfficiencyFailed = false; //Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros
    for (var i = 0; i < this.results.length; i++) {
      for (var j = 0; j < this.results[i].results.length; j++) {

        //Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros - START
        if (!this.sharedService.CalculationForEfficiencyFailed) {
          if (this.results[i].results[j].Efficiency.length === 1 && this.results[i].results[j].LifeTimeHours.length === 1) {
            if (this.results[i].results[j].Efficiency[0] === 0 && this.results[i].results[j].LifeTimeHours[0] === 0) {
              this.sharedService.CalculationForEfficiencyFailed = true;
            }
          }
        }
        //Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros - END


        //Convert to locale values
        //this.results[i].results[j].totalWeight = this.sharedService.formatValue(parseFloat(this.results[i].results[j].totalWeight),this.userInfoService.userData.currentLocale);

        //Find LifeTimeHours for 50% efficiency
        var IndexFor50PercentEff = 0;
        var found = false;
        for (var k = 0; k < this.results[i].results[j].Efficiency.length; k++) {
          if (this.sharedService.convertLocaletoNumber(this.results[i].results[j].Efficiency[k], this.NumberFormat) == 50) {
            IndexFor50PercentEff = k;
            found = true;
            break;
          }
        }

        if (found) {
          this.results[i].results[j].LifeTimeHoursFor50Percent = this.sharedService.formatValue(parseFloat(this.results[i].results[j].LifeTimeHours[IndexFor50PercentEff]).toFixed(1), this.userInfoService.userData.currentLocale);
          this.results[i].results[j].LifeTimeHoursFor50PercentForDisplay = this.sharedService.formatValue(parseFloat(this.results[i].results[j].LifeTimeHours[IndexFor50PercentEff]).toFixed(1), this.userInfoService.userData.currentLocale);
        } else { //Find nearest 50%         
          var goal = 50;

          var closest = 0;
          var printSpecialSign = "";
          if (this.results[i].results[j].Efficiency.length > 0) {
            closest = this.results[i].results[j].Efficiency.reduce(function (prev, curr) {
              return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
            });
          }

          var efficiencyLength = this.results[i].results[j].Efficiency.length;
          var highestValInArray = this.results[i].results[j].Efficiency[efficiencyLength - 1];

          const maxVal = this.results[i].results[j].Efficiency.reduce((a, b) => Math.max(a, b), -Infinity);
          var IndexFor50PercentEff = 0;
          var secondfound = false;
          if (maxVal < 50) {
            secondfound = false;
          } else {
            for (var k = 0; k < this.results[i].results[j].Efficiency.length; k++) {
              if (this.sharedService.convertLocaletoNumber(this.results[i].results[j].Efficiency[k], this.NumberFormat) == closest) {
                IndexFor50PercentEff = k;
                secondfound = true;
                if (highestValInArray > 50) {
                  printSpecialSign = "> ";
                }
                if (highestValInArray < 50) {
                  printSpecialSign = "";
                }
                break;
              }
            }
          }

          if (secondfound) {
            this.results[i].results[j].LifeTimeHoursFor50Percent = this.sharedService.formatValue(parseFloat(this.results[i].results[j].LifeTimeHours[IndexFor50PercentEff]).toFixed(1), this.userInfoService.userData.currentLocale);
            this.results[i].results[j].LifeTimeHoursFor50PercentForDisplaySign = printSpecialSign;
          } else {
            this.results[i].results[j].LifeTimeHoursFor50Percent = "NA";
            this.results[i].results[j].LifeTimeHoursFor50PercentForDisplaySign = printSpecialSign;
          }
        }
      }
    }

    //Find Max Number of Medias for all solutions
    //Want to bring this over?
  }

  onMouseClick(e: MouseEvent) {
    var abc = 123;
  }

  selSection(data) {
    this.selected = data;
    var x = document.getElementById('divSnapshot');
    switch (this.selected) {
      case 'Snapshot':
        this.getViewinReport();
        if (x != null || x != undefined) {
          x.style.display = 'block';
        }
        break;
      case 'Comparison':
        x.style.display = 'none';
        break;
    }

    setTimeout(() => {
      if (data == 'Snapshot') {
        var x = document.getElementById('divSnapshot');
        x.style.display = 'block';
      }

      if (data === 'Comparison') {
        this.populateDataIntoEffiVsLifeTimeTable();
        this.populateDataToComparisonChartComponents();
      }
    }, 1);
  }

  setState(selectedSolId: any) {
    this.state = selectedSolId;
    this.selectedSolution = {};

    let tmpSelSol = [];
    //let contamination = this.contamination;
    let solDet = this.solutions.filter(sol => sol.solutionID === selectedSolId);
    let tmpResult = this.results.filter(sol => sol.solutionID === selectedSolId);

    //let result = [];
    //let tmpResults = [];
    let selResults = [];
    for (var a = 0; a < tmpResult[0].results.length; a++) {
      let eachMediaResults = {
        AtmPressure: tmpResult[0].results[a].AtmPressure,
        Calc_B: tmpResult[0].results[a].Calc_B,
        Calc_Kv: tmpResult[0].results[a].Calc_Kv,
        Calc_we: tmpResult[0].results[a].Calc_we,
        combinationGas: tmpResult[0].results[a].combinationGas,
        combinationID: tmpResult[0].results[a].combinationID,
        contactTime: tmpResult[0].results[a].contactTime,
        EffHoursChart: tmpResult[0].results[a].EffHoursChart,
        //Efficiency: tmpResult[0].results[a].Efficiency,
        Efficiency: [],
        effMediaWeight: tmpResult[0].results[a].effMediaWeight,
        ExcelFileName: tmpResult[0].results[a].ExcelFileName,
        filterDBName: tmpResult[0].results[a].filterDBName,
        filterName: tmpResult[0].results[a].filterName,
        FilterTypeFilterID: tmpResult[0].results[a].FilterTypeFilterID,
        frontVelocity: tmpResult[0].results[a].frontVelocity,
        //LifeTimeHours: tmpResult[0].results[a].LifeTimeHours,
        LifeTimeHours: [],
        EfficiencyForGraph: [], //Modified by PP(2021-01-20) : To touch Y Axis
        LifeTimeHoursForGraph: [], //Modified by PP(2021-01-20) : To touch Y Axis
        molecularGroup: tmpResult[0].results[a].molecularGroup,
        molecularGroupID: tmpResult[0].results[a].molecularGroupID,
        molecularID: tmpResult[0].results[a].molecularID,
        molecularType: tmpResult[0].results[a].molecularType,
        molecularTypeID: tmpResult[0].results[a].molecularTypeID,
        msg: tmpResult[0].results[a].msg,
        pressureDrop: tmpResult[0].results[a].pressureDrop,
        totalWeight: tmpResult[0].results[a].totalWeight,
        vFa: tmpResult[0].results[a].vFa,
        vFFa: tmpResult[0].results[a].vFFa,
        vFv: tmpResult[0].results[a].vFv,
        vWcf: tmpResult[0].results[a].vWcf,
      }

      // Assign Efficiency and LifeTime Hours
      for (var b = 0; b < tmpResult[0].results[a].Efficiency.length; b++) {
        eachMediaResults.Efficiency.push(tmpResult[0].results[a].Efficiency[b]);
      }

      for (var b = 0; b < tmpResult[0].results[a].LifeTimeHours.length; b++) {
        eachMediaResults.LifeTimeHours.push(tmpResult[0].results[a].LifeTimeHours[b]);
      }

      //Modified by PP(2021-01-20) : To touch Y Axis - START
      // Assign Efficiency and LifeTime Hours
      for (var b = 0; b < tmpResult[0].results[a].EfficiencyForGraph.length; b++) {
        eachMediaResults.EfficiencyForGraph.push(tmpResult[0].results[a].EfficiencyForGraph[b]);
      }

      for (var b = 0; b < tmpResult[0].results[a].LifeTimeHoursForGraph.length; b++) {
        eachMediaResults.LifeTimeHoursForGraph.push(tmpResult[0].results[a].LifeTimeHoursForGraph[b]);
      }
      //Modified by PP(2021-01-20) : To touch Y Axis - END

      selResults.push(eachMediaResults);
    }

    //Get ready gasses information
    for (var i = 0; i < selResults.length; i++) {
      for (var j = 0; j < selResults[i].combinationGas.length; j++) {
        for (var k = 0; k < this.contamination.gasDetails.length; k++) {
          //Modified by PP(2023-06-07) : Allow same gas diff conc value if (selResults[i].combinationGas[j].ChemicalID == this.contamination.gasDetails[k].chemicalID) {
          if (selResults[i].combinationGas[j].Index == this.contamination.gasDetails[k].index) { //Modified by PP(2023-06-07) : Allow same gas diff conc value
            //30thMar2023 if (selResults[i].combinationGas[j].ContaminationType == this.contamination.gasDetails[k].contaminationType) {
            //Modified by PP(2023-06-07) : Allow same gas diff conc value selResults[i].combinationGas[j].concentrationValue = this.contamination.gasDetails[k].concentrationValue;
            selResults[i].combinationGas[j].altConcValue = this.contamination.gasDetails[k].altConcValue;
            selResults[i].combinationGas[j].AltConcUnit = this.contamination.gasDetails[k].altConcUnit;
            selResults[i].combinationGas[j].gasWarningColor = this.contamination.gasDetails[k].gasWarningColor;
            selResults[i].combinationGas[j].gasWarningDetail = this.contamination.gasDetails[k].gasWarningDetail;
            selResults[i].combinationGas[j].moreInformation = this.contamination.gasDetails[k].moreInformation;
            selResults[i].combinationGas[j].otherGas = this.contamination.gasDetails[k].otherGas;
            selResults[i].combinationGas[j].otherGasDetails = this.contamination.gasDetails[k].otherGasDetails;
            selResults[i].combinationGas[j].displayTypeForMoreInfo = "More Information";
            //}
          }

          //Assign Color into Gas for Comparison page as Legend
          switch (k) {
            case 0:
              //Modified by PP(2024-06-18) : To follow Color Code from Results page - START
              //this.contamination.gasDetails[k].colorCode = 'Blue';
              //this.contamination.gasDetails[k].colorForResultPage = 'SmallBlue.png';
              this.contamination.gasDetails[k].colorCode = 'Green';
              this.contamination.gasDetails[k].colorForResultPage = 'SmallGreen.png';
              //Modified by PP(2024-06-18) : To follow Color Code from Results page - END
              break;
            case 1:
              this.contamination.gasDetails[k].colorCode = 'Gray';
              this.contamination.gasDetails[k].colorForResultPage = 'SmallGray.png';
              break;
            case 2:
              this.contamination.gasDetails[k].colorCode = 'Yellow';
              this.contamination.gasDetails[k].colorForResultPage = 'SmallYellow.png';
              break;
          }
        }
      }

      //Set Locale into this class and not projectdetails.results so that it wont affect rounding of decimals when switch between us and si
      selResults[i].effMediaWeight = this.sharedService.formatValue(parseFloat(selResults[i].effMediaWeight.toFixed(2)), this.userInfoService.userData.currentLocale);
      selResults[i].totalWeight = this.sharedService.formatValue(parseFloat(selResults[i].totalWeight.toFixed(2)), this.userInfoService.userData.currentLocale);
      selResults[i].frontVelocity = this.sharedService.formatValue(parseFloat(selResults[i].frontVelocity.toFixed(2)), this.userInfoService.userData.currentLocale);
      selResults[i].pressureDrop = this.sharedService.formatValue(parseFloat(selResults[i].pressureDrop.toFixed(2)), this.userInfoService.userData.currentLocale);
      selResults[i].contactTime = this.sharedService.formatValue(parseFloat(selResults[i].contactTime.toFixed(2)), this.userInfoService.userData.currentLocale);
      selResults[i].AtmPressure = this.sharedService.formatValue(parseFloat(selResults[i].AtmPressure.toFixed(2)), this.userInfoService.userData.currentLocale);

      for (var l = 0; l < selResults[i].Efficiency.length; l++) {
        selResults[i].Efficiency[l] = this.sharedService.formatValue(parseFloat(selResults[i].Efficiency[l]), this.userInfoService.userData.currentLocale);
      }

      //4.2 to show as 4.20 but toFixed(2) isn't working
      for (var l = 0; l < selResults[i].LifeTimeHours.length; l++) {
        selResults[i].LifeTimeHours[l] = this.sharedService.formatValue((selResults[i].LifeTimeHours[l]).toFixed(3), this.userInfoService.userData.currentLocale);
      }

      //Modified by PP(2021-01-20) : To touch Y Axis - START
      for (var l = 0; l < selResults[i].EfficiencyForGraph.length; l++) {
        selResults[i].EfficiencyForGraph[l] = this.sharedService.formatValue(parseFloat(selResults[i].EfficiencyForGraph[l]), this.userInfoService.userData.currentLocale);
      }

      for (var l = 0; l < selResults[i].LifeTimeHoursForGraph.length; l++) {
        selResults[i].LifeTimeHoursForGraph[l] = this.sharedService.formatValue(parseFloat(selResults[i].LifeTimeHoursForGraph[l]), this.userInfoService.userData.currentLocale);
      }
      //Modified by PP(2021-01-20) : To touch Y Axis - END
    }

    let sol = {
      id: solDet[0].solutionID,
      name: solDet[0].solutionName,
      contamination: this.contamination,
      solutionDetails: solDet[0].solutionDetails,
      resultReady: tmpResult[0].resultReady,
      results: selResults
    }
    tmpSelSol.push(sol);
    this.selectedSolution = tmpSelSol;

    //Find Max Number of Medias for all solutions
    var TotalResultsLengthForAllSols = [];
    for (var i = 0; i < this.results.length; i++) {
      TotalResultsLengthForAllSols.push(this.results[i].results.length);
    }

    var maxIndex = 0;
    for (var i = 0; i < TotalResultsLengthForAllSols.length; i++) {
      if (TotalResultsLengthForAllSols[maxIndex] < TotalResultsLengthForAllSols[i]) {
        maxIndex = i;
      }
    }
    this.MaxNumOfMedia = TotalResultsLengthForAllSols[maxIndex];

    this.assignColorForGasCombinations();
    //this.populateDataToChartComponents();

    setTimeout(() => {
      this.populateDataToChartComponents();

      for (var i = 0; i < 3; i++) {
        for (var j = 0; j < 3; j++) {
          var divName = 'divMoreInfoForGas' + i + j;
          let div = document.getElementById(divName);
          if (div != null || div != undefined) {
            div.style.display = 'none';
          }
        }
      }

      //Efficiency vs LifeTimeHours Table
      for (var l = 0; l < this.selectedSolution[0].results.length; l++) {
        var molecularResult = this.selectedSolution[0].results[l];
        var strHTML = '<table id = "tabEffiG' + l + '" width="80%"><tr><td width="40%"><label>Efficiency,[%]</label></td><td width="60%"><label>Life Time Hours,[hours]</label>';
        if (molecularResult.Efficiency !== null && molecularResult.Efficiency !== undefined && molecularResult.Efficiency.length > 0) {
          for (var m = 0; m < molecularResult.Efficiency.length; m++) {
            var tmpLifeTimeHoursVal = this.sharedService.convertLocaletoNumber(molecularResult.LifeTimeHours[m], this.NumberFormat);
            if (m % 2 == 0) {
              if (tmpLifeTimeHoursVal < 1) {
                strHTML += '<tr><td width="40%" style="background:#ebe8df;"><label>' + molecularResult.Efficiency[m] + '</label></td><td width="60%" style="background:#ebe8df;"><label>' + molecularResult.LifeTimeHours[m] + '</label></td></tr>';
              }
              if (tmpLifeTimeHoursVal > 1) {
                var noDecimalForLifeTimeHours = tmpLifeTimeHoursVal.toFixed(0);
                var noDecimalInLocale = this.sharedService.formatValue(parseFloat(noDecimalForLifeTimeHours), this.userInfoService.userData.currentLocale);
                strHTML += '<tr><td width="40%" style="background:#ebe8df;"><label>' + molecularResult.Efficiency[m] + '</label></td><td width="60%" style="background:#ebe8df;"><label>' + noDecimalInLocale + '</label></td></tr>';
              }
            } else {
              if (tmpLifeTimeHoursVal < 1) {
                strHTML += '<tr><td width="40%" class="forColumnsInEfficiency"><label>' + molecularResult.Efficiency[m] + '</label></td><td width="60%" class="forColumnsInEfficiency"><label>' + molecularResult.LifeTimeHours[m] + '</label></td></tr>';
              }
              if (tmpLifeTimeHoursVal > 1) {
                var noDecimalForLifeTimeHours = tmpLifeTimeHoursVal.toFixed(0);
                var noDecimalInLocale = this.sharedService.formatValue(parseFloat(noDecimalForLifeTimeHours), this.userInfoService.userData.currentLocale);
                strHTML += '<tr><td width="40%" class="forColumnsInEfficiency"><label>' + molecularResult.Efficiency[m] + '</label></td><td width="60%" class="forColumnsInEfficiency"><label>' + noDecimalInLocale + '</label></td></tr>';
              }
            }
          }
        } else {

        }
        strHTML += '</table>';

        var divName = 'divEffVsLife' + l;
        let div = document.getElementById(divName);
        div.innerHTML = strHTML;
      }
    }, 10);
  }

  assignColorForGasCombinations() {
    for (var i = 0; i < this.results.length; i++) {
      for (var j = 0; j < this.results[i].results.length; j++) {
        var ColorCodeForGas = 'Long';
        for (var k = 0; k < this.results[i].results[j].combinationGas.length; k++) {
          for (var l = 0; l < this.contamination.gasDetails.length; l++) {
            //Modified by PP(2023-06-07) : Allow same gas diff conc value if ( this.results[i].results[j].combinationGas[k].ChemicalID == this.contamination.gasDetails[l].chemicalID) {
            if (this.results[i].results[j].combinationGas[k].Index == this.contamination.gasDetails[l].index) { //Modified by PP(2023-06-07) : Allow same gas diff conc value
              //No need to check this because contamination.gasdetails = Others will solutiondetails is Others-Crysenol  if ( this.results[i].results[j].combinationGas[k].ContaminationType == this.contamination.gasDetails[l].contaminationType) {
              ColorCodeForGas = ColorCodeForGas + this.contamination.gasDetails[l].colorCode;
              //No need to check this because contamination.gasdetails = Others will solutiondetails is Others-Crysenol }
            }
          }
        }
        this.results[i].results[j].colorForResultPage = ColorCodeForGas + '.png';
      }
    }
  }

  populateDataToChartComponents() {
    let usrlocale = this.userInfoService.userData.currentLocale;
    this.data_EffvsLifeTimeEChart = [];
    this.legend_EffvsLifeTimeEChart = [];

    //Initialize echarts instance
    var myChart = echarts.init(document.getElementById('divEffvsLifeGraph'));

    // Get data from results
    if (this.selectedSolution[0].results != undefined) {
      let points = [];
      let seriesdata = [];
      let seriesColor = ""; //Modified by PP(2023-01-20) : Follow Camfil Colors

      for (var i = 0; i < this.selectedSolution[0].results.length; i++) {
        // if (this.selectedSolution[0].results[i].) {

        // }
        points = [];
        for (var j = 0; j < this.selectedSolution[0].results[i].LifeTimeHoursForGraph.length; j++) {
          seriesColor = this.gAryColors[i]; //Modified by PP(2023-01-20) : Follow Camfil Colors

          //Modified by PP(2021-01-20) : To touch Y Axis - START
          //let lthours = this.sharedService.convertLocaletoNumber(this.selectedSolution[0].results[i].LifeTimeHours[j], this.NumberFormat);
          //let eff = this.sharedService.convertLocaletoNumber(this.selectedSolution[0].results[i].Efficiency[j], this.NumberFormat);
          let lthours = this.sharedService.convertLocaletoNumber(this.selectedSolution[0].results[i].LifeTimeHoursForGraph[j], this.NumberFormat);
          let eff = this.sharedService.convertLocaletoNumber(this.selectedSolution[0].results[i].EfficiencyForGraph[j], this.NumberFormat);
          //Modified by PP(2021-01-20) : To touch Y Axis - END

          let point = [lthours, eff];
          points.push(point);

          //Get all xAxis Data
          //this.xAxis_EffvsLifeTimeEChart.push(lthours);

          //Get all yAxis Data
          //this.yAxis_EffvsLifeTimeEChart.push(eff);
        }
        let gasName = this.selectedSolution[0].results[i].combinationGas[0].ContaminationType; //'Modified by PP(2024-06-18) : To add Gas Name into comparison report
        let eachMedia = gasName + " , " + this.selectedSolution[0].results[i].molecularType + " : " + this.selectedSolution[0].results[i].filterName;
        this.legend_EffvsLifeTimeEChart.push(eachMedia);

        this.data_EffvsLifeTimeEChart.push({
          name: gasName + " , " + this.selectedSolution[0].results[i].molecularType + " : " + this.selectedSolution[0].results[i].filterName,
          type: 'line',
          symbolSize: 10,
          symbol: 'circle',
          smooth: true,
          data: points,
          color: seriesColor //Modified by PP(2023-01-20) : Follow Camfil Colors
        });
      }

      //Sort xAxis Data
      // this.xAxis_EffvsLifeTimeEChart.sort((a, b) => {
      //   return a - b;
      // });

      //Sort xAxis Data
      // this.yAxis_EffvsLifeTimeEChart.sort((a, b) => {
      //   return a - b;
      // });
    } //if (this.selectedSolution[0].results != undefined)

    // Specify configuration items and data for the chart
    var option;
    option = {
      legend: {
        data: this.legend_EffvsLifeTimeEChart
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          var tooltipText = "";
          var formattedValue;
          formattedValue = (parseFloat(params[0].value[0])).toLocaleString(usrlocale);
          var formattedEfficiency;
          formattedEfficiency = (parseFloat(params[0].value[1])).toLocaleString(usrlocale);
          tooltipText += formattedValue;
          tooltipText += '<br/>' + params[0].seriesName + '<br/>' + formattedEfficiency;
          return tooltipText;
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        name: 'LifeTime Hours [hours]',
        nameLocation: 'middle',
        nameGap: 30,
        axisLabel: {
          formatter: function (value) {
            return value.toLocaleString(usrlocale);
          }
          //formatter: '{value}',          
        },
        min: 0 //Modified by PP(2021-01-20) : To touch Y Axis
      },
      yAxis: {
        type: 'value',
        name: 'Efficiency [%]',
        nameLocation: 'middle',
        nameGap: 50,
        axisLine: { onZero: false },
        axisLabel: {
          formatter: function (value) {
            return value.toLocaleString(usrlocale);
          }
          //formatter: '{value}'
        },
        boundaryGap: false,
        max: 100
      },
      series: this.data_EffvsLifeTimeEChart
    };

    myChart.setOption(option, true); //true is to clear previous chart
  }

  showHideInfoToggle(event) {
    let SnapshotInfo = document.getElementById('divSnapshotInfo');
    let ComparisonInfo = document.getElementById('divComparisonInfo');

    if (!this.SnapshotInfo && event === 'SnapshotInfo') {
      SnapshotInfo.setAttribute('data-show', '');
      this.SnapshotInfo = true;
    } else if (this.SnapshotInfo && event === 'SnapshotInfo') {
      SnapshotInfo.removeAttribute('data-show');
      this.SnapshotInfo = false;
    }

    if (!this.ComparisonInfo && event === 'ComparisonInfo') {
      ComparisonInfo.setAttribute('data-show', '');
      this.ComparisonInfo = true;
    } else if (this.ComparisonInfo && event === 'ComparisonInfo') {
      ComparisonInfo.removeAttribute('data-show');
      this.ComparisonInfo = false;
    }

  }

  setPoppers() {
    let SnapshotInfoBtn = document.querySelector('#SnapshotInfoBtn');
    let SnapshotInfo = document.getElementById('divSnapshotInfo');

    let ComparisonInfoBtn = document.querySelector('#ComparisonInfoBtn');
    let ComparisonInfo = document.getElementById('divComparisonInfo');

    this.createPopBottom(SnapshotInfoBtn, SnapshotInfo);
    this.createPopBottom(ComparisonInfoBtn, ComparisonInfo);
  }

  createPopBottom(ref: any, popper: any) {
    createPopper(ref, popper, {
      placement: 'bottom-start',
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [-70, 8],
          },
        },
      ],
    });
  }

  //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START
  /*getChemInfo(pChemID: number) {
    var chemInfo: any;
    for (var x=0;x<this.AllDDLList.ApplicationContaminationFromServer.AMCChemical.length;x++) {
      if (pChemID == this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalID) {
        chemInfo = {
          contamination_type : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Substance,
          chemical_id : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalID,
          chemicalFormula : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Formula,
          vapourPressureValue : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Vp,
          molecularWeight : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Mw,
          boilingPoint : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Tbp,
          cas_no : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].CasNo,
          density : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].dL,
          refractiveIndex : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].RI,
          chemical_warning : this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].ChemicalWarning,
          gasWarningColor : parseInt(this.AllDDLList.ApplicationContaminationFromServer.AMCChemical[x].Importancy)
        }
        break;
      }
    }
    return chemInfo
  }*/
  //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-END

  startCalculateConcentration(pConcValue: any, pConcUnit: any, pChemInfo: any, pItem: any, pIndex: number, isOtherGas: boolean) {
    var CalculatedConcValue: any;

    // If US unit
    var returnValueVPa = undefined;
    var tmpBoiling_point = undefined;

    if (this.projectService.projectdetails.projectInfo.unitId == 2) {
      //Boiling Point
      tmpBoiling_point = this.calculateService.ConvertTemperature(this.sharedService.convertLocaletoNumber(pChemInfo.boilingPoint, this.NumberFormat), 'US');

      //Vapour Pressure
      // Not converttemperature. should be cld2.0 bugs returnValueVPa = this.calculateService.ConvertTemperature(this.sharedService.convertLocaletoNumber(pChemInfo.vapourPressureValue, this.NumberFormat), 'US');
      returnValueVPa = this.calculateService.ConvertVapourPa(this.sharedService.convertLocaletoNumber(pChemInfo.vapourPressureValue, this.NumberFormat), 'US');
      pChemInfo.vapourPressureValue = returnValueVPa.toFixed(2);

      //pplim test
      //pChemInfo.vapourPressureValue = 123;
    } else {
      returnValueVPa = this.sharedService.convertLocaletoNumber(pChemInfo.vapourPressureValue, this.NumberFormat); //27.9 while boiling_point = 56.2 / unitId = 1

      //pplim test
      //returnValueVPa = 456;
    }

    //Calculate Concentration Value
    CalculatedConcValue = this.calculateService.CalculateConcentration(pConcValue, pConcUnit, this.projectService.projectdetails.projectInfo.unitId, this.NumberFormat, this.contamination.temperature, this.sharedService.convertLocaletoNumber(pChemInfo.molecularWeight, this.NumberFormat));

    //pplim test
    //CalculatedConcValue = 789;

    return CalculatedConcValue;
  }

  moreInfo(pCombinationIndex: number, pCombinationGasIndex: number) {
    var divName = 'divMoreInfoForGas' + pCombinationIndex + pCombinationGasIndex;
    let div = document.getElementById(divName);

    let DisplayType = this.selectedSolution[0].results[pCombinationIndex].combinationGas[pCombinationGasIndex].displayTypeForMoreInfo;
    switch (DisplayType) {
      case "More Information":
        div.style.display = 'block';
        this.selectedSolution[0].results[pCombinationIndex].combinationGas[pCombinationGasIndex].displayTypeForMoreInfo = "Collapse";
        break;

      case "Collapse":
        div.style.display = 'none';
        this.selectedSolution[0].results[pCombinationIndex].combinationGas[pCombinationGasIndex].displayTypeForMoreInfo = "More Information";
        break;
    }
    var abc = 123;
  }

  getMoreInfoForContamination() {
    for (var x = 0; x < this.projectService.projectdetails.contamination.gasDetails.length; x++) {
      let ChemInfo = this.sharedService.getChemInfo(this.projectService.projectdetails.contamination.gasDetails[x].chemicalID); //Modified by PS(2023-03-22): MCCLD 2023-Fetch Chemical List-START

      let newMoreInfo = this.projectService.getmoreInfoForGasEmptyvalueStructure();
      if (ChemInfo != undefined) { //If undefined means previously saved other people's other gas
        newMoreInfo.chemicalFormula = ChemInfo.chemicalFormula;

        newMoreInfo.vapourPressureValue = this.sharedService.formatValue(ChemInfo.vapourPressureValue, true);
        newMoreInfo.boilingPoint = this.sharedService.formatValue(ChemInfo.boilingPoint, true);

        //pplim 20251002: vapourPressureValue & boilingPoint (has result)
        if (this.projectService.projectdetails.projectInfo.unitId == 2) {
          newMoreInfo.vapourPressureValue = this.calculateService.ConvertVapourPa(this.sharedService.convertLocaletoNumber(ChemInfo.vapourPressureValue, this.NumberFormat), 'US');
          newMoreInfo.vapourPressureValue = this.sharedService.formatValue(newMoreInfo.vapourPressureValue.toFixed(2), true);
          newMoreInfo.boilingPoint = this.calculateService.ConvertTemperature(this.sharedService.convertLocaletoNumber(ChemInfo.boilingPoint, this.NumberFormat), 'US');
          newMoreInfo.boilingPoint = this.sharedService.formatValue(newMoreInfo.boilingPoint, true);
        }

        newMoreInfo.molecularWeight = this.sharedService.formatValue(ChemInfo.molecularWeight, true);
        newMoreInfo.casNo = ChemInfo.cas_no;
        this.projectService.projectdetails.contamination.gasDetails[x].moreInformation = newMoreInfo;
        this.projectService.projectdetails.contamination.gasDetails[x].gasWarningDetail = ChemInfo.chemical_warning; //Modified by PP(2023-02-15) : Load Project go Results it re-generates
      }
    }
  }

  populateDataToComparisonChartComponents() {
    let usrlocale = this.userInfoService.userData.currentLocale;
    this.data_ComparisonEffvsLifeTimeEChart = [];
    this.legend_ComparisonEffvsLifeTimeEChart = [];

    //Initialize echarts instance
    var myChart = echarts.init(document.getElementById('divEffvsLifeComparisonGraph'));

    // Get data from results
    if (this.results != undefined) {
      for (var i = 0; i < this.results.length; i++) {
        let points = [];
        let seriesdata = [];
        let seriesColor = "";
        seriesColor = this.gAryColors[i]; //One solution one color

        if (this.results[i].resultReady === true) {
          for (var j = 0; j < this.results[i].results.length; j++) {
            points = [];

            for (var k = 0; k < this.results[i].results[j].LifeTimeHoursForGraph.length; k++) {
              let lthours = this.sharedService.convertLocaletoNumber(this.results[i].results[j].LifeTimeHoursForGraph[k], this.NumberFormat);
              let eff = this.sharedService.convertLocaletoNumber(this.results[i].results[j].EfficiencyForGraph[k], this.NumberFormat);

              let point = [lthours, eff];
              points.push(point);
            }
            let gasName = this.results[i].results[j].combinationGas[0].ContaminationType; //'Modified by PP(2024-06-18) : To add Gas Name into comparison report
            let eachMedia = gasName + " , " + this.solutions[i].solutionName + " (" + this.results[i].results[j].molecularType + " : " + this.results[i].results[j].filterName + " )";
            this.legend_ComparisonEffvsLifeTimeEChart.push(eachMedia);

            this.data_ComparisonEffvsLifeTimeEChart.push({
              name: gasName + " , " + this.solutions[i].solutionName + " (" + this.results[i].results[j].molecularType + " : " + this.results[i].results[j].filterName + " )",
              type: 'line',
              symbolSize: 10,
              symbol: 'circle',
              smooth: true,
              data: points,
              color: seriesColor //Modified by PP(2023-01-20) : Follow Camfil Colors
            });
          }
        }

      }
    }

    var option;
    option = {
      legend: {
        data: this.legend_ComparisonEffvsLifeTimeEChart
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          var tooltipText = "";
          var formattedValue;
          formattedValue = (parseFloat(params[0].value[0])).toLocaleString(usrlocale);
          var formattedEfficiency;
          formattedEfficiency = (parseFloat(params[0].value[1])).toLocaleString(usrlocale);
          tooltipText += formattedValue;
          tooltipText += '<br/>' + params[0].seriesName + '<br/>' + formattedEfficiency;
          return tooltipText;
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        name: 'LifeTime Hours [hours]',
        nameLocation: 'middle',
        nameGap: 30,
        axisLabel: {
          formatter: function (value) {
            return value.toLocaleString(usrlocale);
          }
          //formatter: '{value}',          
        },
        min: 0 //Modified by PP(2021-01-20) : To touch Y Axis
      },
      yAxis: {
        type: 'value',
        name: 'Efficiency [%]',
        nameLocation: 'middle',
        nameGap: 50,
        axisLine: { onZero: false },
        axisLabel: {
          formatter: function (value) {
            return value.toLocaleString(usrlocale);
          }
          //formatter: '{value}'
        },
        boundaryGap: false,
        max: 100
      },
      series: this.data_ComparisonEffvsLifeTimeEChart
    };

    myChart.setOption(option, true); //true is to clear previous chart
  }

  populateDataIntoEffiVsLifeTimeTable() {
    //Efficiency vs LifeTimeHours Table
    for (var i = 0; i < this.results.length; i++) {
      if (this.results[i].resultReady === true) {
        for (var j = 0; j < this.results[i].results.length; j++) {
          var molecularResult = this.results[i].results[j];
          var strHTML = '<table id = "tabEffiCompare' + i + '" width="80%"><tr><td width="40%"><label>Efficiency,[%]</label></td><td width="60%"><label>Life Time Hours,[hours]</label>';
          if (molecularResult.Efficiency !== null && molecularResult.Efficiency !== undefined && molecularResult.Efficiency.length > 0) {
            for (var m = 0; m < molecularResult.Efficiency.length; m++) {
              var EffiInLocale = this.sharedService.formatValue(parseFloat(molecularResult.Efficiency[m]), this.userInfoService.userData.currentLocale);
              var LifeTimeiInLocale = this.sharedService.formatValue(parseFloat(molecularResult.LifeTimeHours[m]), this.userInfoService.userData.currentLocale);

              var LifeTimeHoursNoLocale = this.sharedService.convertLocaletoNumber(molecularResult.LifeTimeHours[m], this.NumberFormat);
              var noDecimalForLifeTimeHours = molecularResult.LifeTimeHours[m].toFixed(0);
              var noDecimalInLocale = this.sharedService.formatValue(parseFloat(noDecimalForLifeTimeHours), this.userInfoService.userData.currentLocale);
              if (m % 2 == 0) {
                if (LifeTimeHoursNoLocale < 1) {
                  strHTML += '<tr><td width="40%" style="background:#ebe8df;"><label>' + EffiInLocale + '</label></td><td width="60%" style="background:#ebe8df;"><label>' + LifeTimeiInLocale + '</label></td></tr>';
                }
                if (LifeTimeHoursNoLocale > 1) {
                  strHTML += '<tr><td width="40%" style="background:#ebe8df;"><label>' + EffiInLocale + '</label></td><td width="60%" style="background:#ebe8df;"><label>' + noDecimalInLocale + '</label></td></tr>';
                }
              } else {
                if (LifeTimeHoursNoLocale < 1) {
                  strHTML += '<tr><td width="40%" class="forColumnsInEfficiency"><label>' + EffiInLocale + '</label></td><td width="60%" class="forColumnsInEfficiency"><label>' + LifeTimeiInLocale + '</label></td></tr>';
                }
                if (LifeTimeHoursNoLocale > 1) {
                  strHTML += '<tr><td width="40%" class="forColumnsInEfficiency"><label>' + EffiInLocale + '</label></td><td width="60%" class="forColumnsInEfficiency"><label>' + noDecimalInLocale + '</label></td></tr>';
                }
              }
            }
          } else {

          }
          strHTML += '</table>';

          var divName = 'divEffVsLifeCompareSol' + i;
          let div = document.getElementById(divName);
          div.innerHTML = strHTML;
        }
      }
    }
  }
}
